import { createSlice } from '@reduxjs/toolkit'
import { PresenterBackground, VirtualBackgrounds } from '../../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'
import apiGateway from '../../../services/apiGateway'
import { addEntry } from '../../../lib/audit'

export interface UserSettingsSlice {
  fetched: boolean,
  presenterBackground: PresenterBackground,
}

export const userSettingsDefaultState: UserSettingsSlice = {
  fetched: false,
  presenterBackground: {
    type: VirtualBackgrounds.NONE,
    customImage: null
  }
}

const userSettingsSlice = createSlice({
  name: 'presenterSettings',
  initialState: userSettingsDefaultState,
  reducers: {
    setSettings( state, { payload }) {
      state.fetched = true
      state.presenterBackground = {
        type: payload.presenterBackground?.type || state.presenterBackground.type,
        customImage: payload.presenterBackground?.customImage || state.presenterBackground.customImage
      }
    }
  }

})

export const fetchSettings = () => async (dispatch, getState) => {

  const { userSettings } = getState()
  let settingsResponse

  try {

    settingsResponse = await apiGateway.fetchUserSettings()

  } catch (e) {

    addEntry('PresenterService', 'UserSettingsFetch', `Error fetching user settings: ${e}.`)

  }
  
  return dispatch(userSettingsSlice.actions.setSettings({...userSettings, 
    presenterBackground: {
      ...userSettings.presenterBackground,
      customImage: settingsResponse ? settingsResponse.data.background.backgroundImageUrl : userSettings.presenterBackground.customImage,
      type: settingsResponse ? settingsResponse.data.background.currentBackground : userSettings.presenterBackground.type
    }}))
}

export const setUserBackground = (backgroundType: VirtualBackgrounds) => async (dispatch, getState) => {
  
  const { userSettings } = getState()

  try {

    await apiGateway.setUserBackground(backgroundType)

  } catch (e) {

    addEntry('PresenterService', 'UserSettingsSettingBackgroundError', `Error setting user background: ${e}.`)
    return

  }

  return dispatch(userSettingsSlice.actions.setSettings({...userSettings, 
    presenterBackground: {
      ...userSettings.presenterBackground,
      type: backgroundType
    }}))
}

export const uploadImage = (file: File) => async (dispatch, getState) => {
  
  const { userSettings } = getState()
  let response
  try {

    response = await apiGateway.uploadVirtualBackgroundImage(file)

  } catch (e) {

    addEntry('PresenterService', 'UserSettingsVirtualBackgroundUploadError', `Error uploading virtual background image: ${e}`)
    return

  }
  return dispatch(userSettingsSlice.actions.setSettings({...userSettings, 
    presenterBackground: {
      ...userSettings.presenterBackground,
      customImage: response.data.secure_url
    }}))
}

export default userSettingsSlice